export default __webpack_public_path__ + "images/15e5767a3c9341ccf0b82c4003a48015-compliance_module.png";